import React from 'react';
import EAPHeroSection from '../components/EAPHeroSection';
import EAPServicesSection from '../components/EAPServicesSection';

const EAPPage: React.FC = () => {
  return (
    <div className="min-h-screen">
      <EAPHeroSection />
      <EAPServicesSection />
    </div>
  );
};

export default EAPPage;